import { gql } from '@apollo/client';
import { useMutation } from '@apollo/client';

export const CREATE_INVENTORY_INSPECTION = gql`
  mutation CreateInventoryInspection($propertyId: ID!, $input: CreateInventoryInspectionInput!) {
    createInventoryInspection(propertyId: $propertyId, input: $input) {
      id
      type
      inspectionDate
      inspectorName
      receiverName
      generalNotes
      sections {
        id
        key
        title
        order
        isSystem
        items {
          id
          title
          quantity
          status
          notes
          order
          files {
            id
            url
          }
        }
      }
    }
  }
`;

export const useCreateInventoryInspectionMutation = () => useMutation(CREATE_INVENTORY_INSPECTION);

export const GENERATE_INVENTORY_INSPECTION_PDF = gql`
  mutation GenerateInventoryInspectionPdf($propertyId: ID!, $inspectionId: ID!) {
    generateInventoryInspectionPdf(propertyId: $propertyId, inspectionId: $inspectionId) {
      url
      fileName
      contentType
    }
  }
`;

export const useGenerateInventoryInspectionPdfMutation = () => useMutation(GENERATE_INVENTORY_INSPECTION_PDF);

